import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import cloneDeep from 'lodash/cloneDeep';

class MultiDataSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchOptions: {},
            activeSelector: ''
        };
        this.updateSearchTerm = this.updateSearchTerm.bind(this);
        this.activateSelector = this.activateSelector.bind(this);
        this.updateMultiSelection = this.updateMultiSelection.bind(this);
        this.onOptionSelection = this.onOptionSelection.bind(this);
    }

    updateSearchTerm(field, searchTerm) {
        this.setState((previousState) => {
            const newSearchOptions = previousState.searchOptions;
            newSearchOptions[field] = searchTerm;
            return newSearchOptions;
        });
    }

    activateSelector(name) {
        if(this.state.activeSelector === name) {
            name = '';
        }
        this.setState({activeSelector: name});
    }

    updateMultiSelection(name, updatedValue) {
        let currentSelections = cloneDeep(this.props.options.filter(option => option.name === this.state.activeSelector).map(option => option.selectedOption)[0]);
        if(currentSelections === undefined) {
            currentSelections = [];
        }
        if (currentSelections.indexOf(updatedValue) > -1) {
            currentSelections.splice(currentSelections.indexOf(updatedValue), 1);
        } else {
            currentSelections.push(updatedValue);
        }
        this.onOptionSelection(name, currentSelections, true);
    }

    onOptionSelection(name, updatedValue, keepCurrentSelection) {
        const dataLoadFinishedP = this.props.onOptionSelection(name, updatedValue);
        if(keepCurrentSelection !== true) {
            dataLoadFinishedP.then(() => {
                this.setState({activeSelector: ''});
            });
        }
    }

    render() {

        const descriptionElem = (option) => option.description !== undefined
            ? <span>
                                    <a data-event='click focus' data-for={'desc-tip-'+option.id} data-tip><span className="brand-colored-tooltip glyphicon glyphicon-question-sign"/></a>
                                    <ReactTooltip globalEventOff='click' className="booking-tooltip" id={'desc-tip-'+option.id} place="top" type="info" effect="float">
                                        <span>{option.description.text}</span>
                                    </ReactTooltip>
                                </span>
            : <span/>;

        const singleOptionSelect = (selectionName, optionsArray, nameField, enableSearch) => {
            const searchFunc = (option) => {
                if(enableSearch === true && option[nameField] !== undefined && this.state.searchOptions[selectionName] !== undefined) {
                    return option[nameField].toLowerCase().indexOf(this.state.searchOptions[selectionName].toLowerCase())>-1;
                }
                return true;
            };

            return (
                    <div className="booking-options" role="tabpanel" aria-labelledby={"tab-"+selectionName}>
                        {optionsArray.filter(searchFunc).map((option, i) => {
                            const onClick = () => {this.onOptionSelection(selectionName, option)};
                            return (<div tabIndex="0" key={i} className="col-md-3 booking-option" onKeyPress={onClick} onClick={onClick}>{option[nameField]} {descriptionElem(option)}</div>)
                        })}
                    </div>
            );
        };

        const multiOptionSelect = (optionsArray, currentSelections) => {
            if(optionsArray !== undefined) {
                return (
                    <div className="equal-height-row">
                        <div className="booking-options">
                            {optionsArray.map((option, i) => {
                                const value = typeof currentSelections !== 'undefined' && currentSelections.indexOf(option.id.toString())>-1;
                                return (
                                    <div key={i} className="col-md-3 booking-option">
                                        <label>
                                            <input type="checkbox" value={value}
                                                   onChange={() => this.updateMultiSelection('extra_services', option.id.toString())}
                                                   checked={value}/>
                                            {option.name}
                                        </label>
                                        {descriptionElem(option)}
                                    </div>
                                )
                            })}
                            <div className="options-next-button info-button" onClick={() => this.activateSelector('')}>Seuraava</div>
                        </div>
                    </div>
                );
            }
            return <div/>
        };

        const optionTitle = (placeholder, selectionName, nameField, searchable, selectedOption, availableOptions) => {
            const classNames = ["booking-options-header-content centered-content"];
            let disabled = false;
            let active = false;
            if(this.state.activeSelector === selectionName) {
                classNames.push("booking-options-header-active");
                active = true;
            }
            if(selectedOption === undefined  && availableOptions && availableOptions.length === 0) {
                classNames.push("booking-options-header-disabled");
                disabled = true;
            }
            const isSearchable = searchable === true && active;
            const value = nameField && selectedOption && !active ? selectedOption[nameField] : placeholder;
            const searchTerm = this.state.searchOptions[selectionName] || '';
            const onClick = () => {
                if(!disabled && !isSearchable) {
                    this.activateSelector(selectionName);
                }
            };
            return (
                <div role="tab" tabIndex="0" id={"tab-"+selectionName} onKeyPress={onClick} onClick={onClick} style={{width: '100%', height: '100%'}}>
                    <div className={classNames.join(" ")}>
                        {this.props.loadingData ? <div className="loader"/> : <div/>}

                        {isSearchable
                            ? <input type="text" autoFocus={isSearchable} placeholder={value} value={searchTerm} onChange={(event) => this.updateSearchTerm(selectionName, event.target.value)}/>
                            : <span>{value}</span>}
                    </div>
                </div>
            );
        };

        const selectableOptions = this.props.options.map(option => {
            const selectableOption = {name: option.name, visible: option.visible()};
            let options = [];
            if(option.multiOptions) {
                options = typeof option.multiOptions === "function" ? option.multiOptions() : option.multiOptions;
                selectableOption.titleElement = () => optionTitle(option.placeHolder, option.name, undefined, option.searchable === true, option.selectedOption, options);
                selectableOption.selector = () => multiOptionSelect(options, option.selectedOption)
            } else {
                options = typeof option.options === "function" ? option.options() : option.options;
                selectableOption.titleElement = () => optionTitle(option.placeHolder, option.name, option.optionNameField, option.searchable === true, option.selectedOption, options);
                selectableOption.selector = () => singleOptionSelect(option.name, options, 'name', option.searchable === true)
            }
            return selectableOption;
        });
        return (
            <div className="tablist-container">
                <div className="equal-height-row tablist-container"  role="tablist">
                    {selectableOptions.filter(option => option.visible).map((option, i) => {
                        return <div className="col-md-2 booking-options-header no-padding" key={i}>{option.titleElement()}</div>
                    })}
                </div>
                <div className="equal-height-row tablist-items">
                    {selectableOptions.filter(option => option.visible && option.name === this.state.activeSelector).map((option, i) => {
                        return <div key={i} className="tablist-container">
                                <div className="mobile-title-element"> {option.titleElement()}</div>
                                {option.selector()}
                               </div>
                    })}
                </div>
            </div>
        );
    }
}

export default MultiDataSelector;


// WEBPACK FOOTER //
// ../components/booking/MultiDataSelector.js